import { render, staticRenderFns } from "./DialogTitle.vue?vue&type=template&id=212e3ce6"
import script from "./DialogTitle.vue?vue&type=script&lang=js"
export * from "./DialogTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports